import { FleetMap } from "@/components/Map";
import { TelemetryPanel } from "@/components/TelemetryPanel";
import { FleetStatusBar } from "@/components/FleetStatusBar";
import { useAppDispatch, useAppSelector, selectDrone } from "@/store";
import { useFleetSocket } from "@/hooks/useFleetSocket";
import { Box, Flex } from "@chakra-ui/react";

export function Dashboard() {
  const dispatch = useAppDispatch();
  const selectedDroneId = useAppSelector((state) => state.fleet.selectedDroneId);

  // Fleet WebSocket connection - shared between status bar and map
  const { connected, drones, setViewport, error } = useFleetSocket();

  const handleClose = () => {
    dispatch(selectDrone(null));
  };

  return (
    <Flex direction="column" h="full">
      <FleetStatusBar connected={connected} drones={drones} error={error} />
      <Box flex="1" minH="0" position="relative">
        <FleetMap drones={drones} setViewport={setViewport} />
        {selectedDroneId && (
          <Box
            position="absolute"
            top="4"
            left="4"
            w="320px"
            maxH="calc(100% - 32px)"
            zIndex="10"
          >
            <TelemetryPanel onClose={handleClose} />
          </Box>
        )}
      </Box>
    </Flex>
  );
}
